import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';

interface HeatmapLayerProps {
  points: [number, number, number][]; // [lat, lng, intensity]
}

export const HeatmapLayer = ({ points }: HeatmapLayerProps) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // Create the heat layer
    // @ts-ignore - L.heatLayer might not be recognized by tsc without full types
    const heatLayer = (L as any).heatLayer(points, {
      radius: 25,
      blur: 15,
      maxZoom: 10,
      minOpacity: 0.5, // Ensure it's not transparent
      zIndex: 1000,     // Force it to the top
    
      // This gradient makes it look like a "hot" thermal map
      gradient: {
        0.4: 'blue',
        0.6: 'cyan',
        0.7: 'lime',
        0.8: 'yellow',
        1.0: 'red'
      }

    }).addTo(map);

    // Cleanup: remove the layer when component unmounts
    return () => {
      map.removeLayer(heatLayer);
    };
  }, [map, points]);

  return null; // This component doesn't render anything itself
};

